import { getField, updateField } from "vuex-map-fields";
import Line from "./line";
import api from "../api/api"

export const namespaced = true;

let baseUrl = "/phreatic_reference_lines/";

const line = new Line(baseUrl);

const getDefaultState = () => {
  return {
    ...structuredClone(line.state),
    color: "blue",
    dash: "solid",
    name: "Phreatic reference line",
    storeNamespace: "phreaticReferenceLine",
    copyLoading: false,
    copyDialog: false,
  };
};

export const state = getDefaultState();

export const mutations = {
  ...line.mutations,
  updateField,
  TOGGLE_COPY_LOADING (state) {
    state.copyLoading = !state.copyLoading
  },
  TOGGLE_COPY_DIALOG (state) {
    state.copyDialog = !state.copyDialog
  },
  SET_GEOMETRY (state, geometry) {
    if (state.currentItem, geometry){
      state.currentItem.geometry = geometry
    }
  }
};

export const actions = {
  ...line.actions,
  toggleCopyDialog (context) {
    context.commit('TOGGLE_COPY_DIALOG')
  },
  async copy(context){
    context.commit('TOGGLE_COPY_LOADING')
    const geometry = await context.rootGetters["phreaticLine/getCurrentGeometry"]
    context.commit('SET_GEOMETRY', geometry)
    context.commit('SET_DIRTY_OBJECT')
    context.dispatch('update')
    context.dispatch('emptyDirtyItems')
    context.commit('TOGGLE_COPY_LOADING')
  },
  async generate(context) {
    context.commit("TOGGLE_GENERATE_LOADING");
    const id = context.rootGetters["stabSchematisationStage/currentStabSchematisationStageId"]
    const currentMultiplePhreaticLine = context.rootState.multiplePhreaticLine.currentItem;
    const url = baseUrl + id + "/generate/"
    try {
      const response = await api.post(url, {
        properties: {multiple_phreatic_line: currentMultiplePhreaticLine.id},
      });
      context.commit("REPLACE_LINE", response.data);
      context.commit("SET_DELETED_ITEM", {
        ...structuredClone(response.data),
      });
      context.commit("SET_COORDINATE");
      context.commit("SET_DELETED_COORDINATE");
    } catch (e) {
      console.log(e);
    }
    context.commit("TOGGLE_GENERATE_LOADING");
  },
};

export const getters = {
  ...line.getters,
  getField,
};
